import { TrackingEvent, TrackingWrapper } from '@js-boot/tracking-wrapper';
import { isLocal, isProduction } from '../@types/stage';

const getTrackingConfiguration = () => {
  const trackingBundleBaseUrl = isProduction()
    ? 'https://tracking.immobilienscout24.de/tr.js'
    : 'https://tracking.sandbox-immobilienscout24.de/tr.js';
  const trackingBundleParameters = {
    counterName: 'is24.de.sicherheit.verifizierung',
    svcModuleName: 'trust_verification_service',
    initialPageView: false,
    reportEventsIndividually: true,
  };
  const logTrackingEventsInConsole = !isProduction();
  const disableTracking = isLocal();

  return {
    trackingBundleBaseUrl,
    trackingBundleParameters,
    logTrackingEventsInConsole,
    disableTracking,
  };
};

export const trackPageView = async (pageTitle: string, triggeredBy: string) => {
  await is24Tracking
    .report(
      {
        pag_pagetitle: pageTitle,
        event_parameter_1: triggeredBy,
      },
      { reportType: 'UTAG_VIEW' },
    )
    .catch();
};

export const trackEvent = async (
  pageName: string,
  eventName: string,
  product: string,
  triggeredBy: string,
  verificationMethod: string,
) => {
  const trackingEventPayload: TrackingEvent = {
    pag_pagetitle: pageName,
    event_name: eventName,
    event_product: product,
    event_parameter_1: triggeredBy,
    event_parameter_2: verificationMethod,
  };
  await is24Tracking.report(trackingEventPayload).catch();
};

const is24Tracking = new TrackingWrapper(getTrackingConfiguration());
